import { ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";

export default function ServiceCard({ service, index = 0 }) {
    const Icon = service.icon;
    return (
        <Link
            to="/ydelser"
            data-testid={`service-card-${service.id}`}
            className="card-ns group p-7 sm:p-8 flex flex-col h-full"
        >
            <div className="flex items-center justify-between mb-6">
                <div className="w-14 h-14 rounded-md bg-[var(--ns-blue-soft)] text-[var(--ns-blue)] grid place-items-center group-hover:bg-[var(--ns-blue)] group-hover:text-white transition-colors">
                    <Icon className="w-7 h-7" strokeWidth={1.6} />
                </div>
                <span className="text-xs font-bold tracking-[0.18em] uppercase text-[var(--ns-muted)]">
                    0{index + 1}
                </span>
            </div>
            <h3 className="font-display font-extrabold text-xl sm:text-2xl text-[var(--ns-text)] mb-3 tracking-tight">
                {service.title}
            </h3>
            <p className="text-[var(--ns-muted)] text-[15px] leading-relaxed flex-1">
                {service.short}
            </p>
            <div className="mt-6 inline-flex items-center gap-2 text-sm font-bold text-[var(--ns-blue)] group-hover:gap-3 transition-all font-display">
                Læs mere
                <ArrowRight className="w-4 h-4 transition-transform group-hover:translate-x-1" />
            </div>
        </Link>
    );
}
